<div v-if="token_exists" class="suggestions-card rounded d-none d-xl-block">
 <div class="suggestions-header d-flex align-items-center justify-content-between">
  
  <h6 class="suggestions-title mb-0">
    Suggested businesses
  </h6>

  <div class="d-flex align-items-center gap-2">
    
    <button
      v-if="can_create_business_profile"
      type="button"
      class="btn btn-sm btn-primary rounded-circle d-flex align-items-center justify-content-center p-0 menu-icon"
      data-bs-toggle="modal"
      data-bs-target="#company_profile_modal"
      title="Add business profile"
      aria-label="Add business profile"
    >
      <i class="bi bi-plus fs-5 fw-bold"></i>
    </button>


  </div>
</div>

  <div v-if="filtered_business.length <= 0" class="suggestions-empty">
    No business profiles found.
  </div>

  <div
    v-for="profile in filtered_business"
    :key="profile.id"
    class="suggestion-row"
    role="button"
    tabindex="0"
    @click="view_profile(profile)"
    @keydown.enter="view_profile(profile)"
  >
    <img
      v-if="get_profile_logo(profile)"
      :src="get_profile_logo(profile)"
      class="suggestion-avatar"
      alt="Business Logo"
    />
    <span v-else class="suggestion-avatar suggestion-initials">
      {{ get_profile_initials(profile) }}
    </span>

    <span class="suggestion-copy">
      <span class="suggestion-name">
        {{ get_profile_name(profile) }}
      </span>
      <span class="suggestion-meta">
        {{ get_profile_meta(profile) }}
      </span>
    </span>

    <button
      type="button"
      class="suggestion-action"
      :class="{ 'is-followed': is_followed_profile(profile) }"
      :disabled="is_following_profile(profile)"
      @click.stop="follow_profile(profile)"
    >
      {{ get_follow_label(profile) }}
    </button>
  </div>
  <div v-if="filtered_business.length > 4" class="text-end">
         <a class="suggestions-see-all " href="/view_business_profiles">
      See all
    </a>
  </div>

</div>
